import hapanaPattern from '@hapana/shared/web/styles/assets/images/hapana-pattern.png'

/** @type {Styles} */
export const styles = {
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: { xs: 3, sm: 5 },
    minHeight: '100vh',
    paddingX: { xs: 2, sm: 3 },
    paddingY: 5,
    backgroundColor: { xs: 'surface.default', sm: 'info.lightest' },
    overflow: 'auto',
  },
  logo: {
    width: { xs: 160, sm: 216 },
    zIndex: 1,
  },
  card: {
    zIndex: 1,
    width: { xs: '100%', sm: 480 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    textAlign: 'center',
    padding: { xs: 3, sm: 5 },
    backgroundColor: 'surface.default',
    borderRadius: { xs: 'unset', sm: 4 },
    borderStyle: { xs: 'unset', sm: 'solid' },
    borderWidth: 1,
    borderColor: 'info.light',
  },
  title: {
    color: 'primary.dark',
  },
  description: {
    color: 'gray.64',
  },
  progress: {
    width: '100%',
    height: 6,
    borderRadius: 3,
    marginTop: 1,
  },
  countdown: {
    color: 'gray.64',
  },
  actions: {
    width: '100%',
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'center',
    gap: 1.5,
    marginTop: 1,
  },
  supportText: {
    color: 'gray.64',
    marginTop: 1,
  },
  supportLink: {
    color: 'primary.main',
    textDecoration: 'none',
  },
  // Dev-only crash detail — never rendered in a production build.
  errorDetails: {
    width: '100%',
    textAlign: 'left',
    backgroundColor: 'info.lightest',
    borderRadius: 2,
    padding: 2,
    marginTop: 1,
    maxHeight: 200,
    overflow: 'auto',
  },
  errorDetailsText: {
    margin: 0,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    color: 'gray.64',
  },
  backgroundPatternImage: {
    backgroundImage: `url(${hapanaPattern})`,
    backgroundSize: 'cover',
    backgroundPosition: 'bottom',
    position: 'absolute',
    height: 248,
    width: '100%',
    bottom: 0,
    left: 0,
    right: 0,
    display: { xs: 'none', sm: 'block' },
  },
}
